export const BROKER_QUALITY_SCORECARD_UNDERWRITING_URL = '/api/command-center/quality-scorecard';
